import { render } from "./FormGroup.vue?vue&type=template&id=b43b5502"
const script = {}

import "./FormGroup.vue?vue&type=style&index=0&id=b43b5502&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__